if (!customElements.get('product-transformation')) {
  class ProductTransformation extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.product-transformation__range');
      if (!this.range) return;

      this.update = this.update.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.range.addEventListener('input', this.update);
      this.range.addEventListener('keydown', this.onKeydown);
      this.update();

      this.querySelector('[data-transformation-cta]')?.addEventListener('click', () => {
        this.scrollToPurchasePanel();
      });
    }

    disconnectedCallback() {
      this.range?.removeEventListener('input', this.update);
      this.range?.removeEventListener('keydown', this.onKeydown);
    }

    update() {
      const value = Number(this.range.value);
      this.style.setProperty('--pt-position', `${value}%`);
      this.range.setAttribute('aria-valuetext', `${value}% след промяната`);
    }

    onKeydown(event) {
      const supportedKeys = ['ArrowLeft', 'ArrowDown', 'ArrowRight', 'ArrowUp', 'Home', 'End'];
      if (!supportedKeys.includes(event.key)) return;

      event.preventDefault();
      const currentValue = Number(this.range.value);
      const step = event.shiftKey ? 10 : 1;
      let nextValue = currentValue;

      if (event.key === 'Home') nextValue = Number(this.range.min);
      if (event.key === 'End') nextValue = Number(this.range.max);
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') nextValue = currentValue - step;
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') nextValue = currentValue + step;

      this.range.value = Math.min(Number(this.range.max), Math.max(Number(this.range.min), nextValue));
      this.update();
    }

    scrollToPurchasePanel() {
      const mainProduct = this.closest('[id^="MainProduct-"]') || document.querySelector('[id^="MainProduct-"]');
      const purchasePanel = mainProduct?.querySelector('.purchase-panel') || document.querySelector('.purchase-panel');
      if (!purchasePanel) return;

      purchasePanel.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });

      const firstCalculatorInput = purchasePanel.querySelector('.ff-naked-input');
      if (!firstCalculatorInput) return;

      const focusCalculator = () => {
        firstCalculatorInput.focus({ preventScroll: true });
        if (document.activeElement !== firstCalculatorInput) firstCalculatorInput.focus();
      };

      focusCalculator();
      window.setTimeout(focusCalculator, 650);
    }
  }

  customElements.define('product-transformation', ProductTransformation);
}
